export default "https://cdn-static.gokick.com/assets/3258f73df43fa954b49bc6bd6de466cccdb5fe2c/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";